"use client";

import { PrismicNextImage } from "@prismicio/next";
import { useState } from "react";

export default function PlayVideo({ slice, onClickPlay }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className="relative overflow-visible w-[98px] h-[98px]">
        <div className="animate-spin-reverse">
          <PrismicNextImage
            className=" w-[98px] h-[98px]"
            field={slice?.rotating_text_image}
            fallbackAlt=""
            priority
            loading="eager"
          />
        </div>
        <PrismicNextImage
          className="cursor-pointer absolute -translate-x-[50%] -translate-y-[50%] top-[50%] left-[50%] w-[38px] h-[38px]"
          field={slice?.play_icon}
          onClick={onClickPlay}
          fallbackAlt=""
          priority
          loading="eager"
        />
      </div>
      {/* <VideoModal
        link={slice?.video_url}
        video={slice?.video}
        show={show}
        onHide={() => setShow(false)}
      /> */}
    </>
  );
}
